import { Injectable } from '@angular/core';

/**
 * Almacena el token usado en local con token estático para que
 * GoogleAuthenticationService pueda decodificarlo y mostrar nombre/email en la UI.
 */
@Injectable({ providedIn: 'root' })
export class StaticTokenHolderService {
  private token: string | null = null;

  setToken(token: string): void {
    this.token = this.normalizeToJwtString(token);
  }

  getToken(): string | null {
    return this.token;
  }

  /**
   * Google / clientes a veces entregan el id_token dentro de un JSON stringificado
   * ({ iss, id_token, ... }). El backend solo acepta el JWT (tres segmentos separados por puntos).
   */
  private normalizeToJwtString(raw: string): string | null {
    const trimmed = raw.trim();
    if (!trimmed) {
      return null;
    }
    if (this.isLikelyJwt(trimmed)) {
      return trimmed;
    }
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed) as { id_token?: string };
        const id = parsed?.id_token?.trim();
        if (id && this.isLikelyJwt(id)) {
          return id;
        }
      } catch {
        // no es JSON válido; se devuelve tal cual
      }
    }
    return trimmed;
  }

  private isLikelyJwt(value: string): boolean {
    return value.split('.').length === 3;
  }
}
